import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationCoauthorRemove: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;
    const { t } = useTranslation();

    if (!info) return null;

    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + info?.account?.accountId}>
            {`${info?.account?.name} ${info?.account?.surName}`}
        </a>
        {` ${t('notifications.coauthor_remove')} `}
        <a href={CreateLinkTo.project(info?.projectId)}>
            {info?.projectTitle}
        </a>
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationCoauthorRemove: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;
    const { t } = useTranslation();

    if (!info) return null;

    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + info?.account?.accountId}>
            {`${info?.account?.name} ${info?.account?.surName}`}
        </a>
        {` ${t('notifications.coauthor_remove')} `}
        <a href={CreateLinkTo.project(info?.projectId)}>
            {info?.projectTitle}
        </a>
    </SimpleTitle>
}